<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain'
}
</script>

<style scoped>
.app-main {
  min-height: 100%;
  width: 100%;
  position: relative;
  overflow: auto;
  padding: 20px;
  box-sizing: border-box;
  background-color: #f0f2f5;
  height: calc(100vh - 50px); /* 减去顶部导航栏高度 */
}
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.5s;
}
.fade-transform-enter,
.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style> 